import {
  duur,
  niveaus,
  type,
  vakgebieden,
  wizardType,
} from "../../shared/filterOptions";
import {
  AnswerOption,
  DevelopmentType,
  KnowingType,
  Questions,
} from "./wizard.types";

export const createOptions = (list: string[]): AnswerOption[] => {
  return list.map((li) => ({
    label: li,
    value: li,
  }));
};

const vakgebiedenOptions: AnswerOption[] = Object.entries({
  ...vakgebieden,
  Overig: "other",
}).map((vg: string[]) => ({
  label: vg[0],
  value: vg[1],
}));

const typeOptions: AnswerOption[] = Object.entries(wizardType).map((vg) => ({
  label: vg[0],
  value: vg[1],
}));

export const questions: Questions = {
  "2": {
    type: "radio",
    title: "Maak jouw plan voor een volgende stap",
    description:
      "We beginnen met de vraag: weet jij welke stap je wil zetten en hoe je daar het beste kunt komen?",
    options: [
      {
        value: KnowingType.Know,
        label: "Ik weet wat ik wil",
        description: "Help mij opleidingen en cursussen ontdekken.",
      },
      {
        value: KnowingType.DontKnow,
        label: "Ik weet nog niet wat ik wil",
        description: "Help mij op weg.",
      },
    ],
  },
  "3.2.1": {
    type: "none",
    title: "Wat past bij jou?",
    description:
      "Welke vakgebieden zijn voor jou interessant? We laten je 15 uitspraken zien. Jij bepaalt of ze bij jou passen.",
  },
  "3.1.1": {
    type: "none",
    title: "Wat is interessant voor jou?",
    description:
      "Welke opleidingen zijn voor jou interessant? We stellen je in totaal 5 vragen. Jij bepaalt welke richting je op wilt.",
  },
  "3.1.2": {
    type: "radio",
    title: "In een paar stappen jouw eigen plan",
    description:
      "Wil je werken in een ander vakgebied of je verder ontwikkelen in je huidige vak? We helpen je bij het verkennen van een nieuwe richting. Dit doen we met een stappenplan. Om de eerste stap te zetten, willen we weten hoe jij je wilt ontwikkelen.",
    options: [
      {
        value: DevelopmentType.Switcher,
        label: "Ik wil een overstap maken naar een ander vakgebied",
      },
      {
        value: DevelopmentType.Upskiller,
        label: "Ik wil mij ontwikkelen binnen mijn huidige vakgebied",
      },
    ],
  },
  "3.1.3.1": {
    type: "checkbox",
    title: "Naar welke sector wil je een overstap maken?",
    description: "Je kunt meerdere antwoorden kiezen.",
    options: vakgebiedenOptions,
  },
  "3.1.3.2": {
    type: "radio",
    title: "Welk vakgebied binnen ons aanbod past bij jou?",
    description: "MaakJeStap richt zich op deze vijf vakgebieden",
    options: vakgebiedenOptions,
  },
  ict1: {
    type: "scale",
    title: "Nauwkeurig werken vind ik belangrijk",
  },
  ict2: {
    type: "scale",
    title: "Ik ben graag de beste in wat ik doe",
  },
  ict3: {
    type: "scale",
    title: "Ik vind het leuk om dingen steeds iets beter te doen",
  },
  zorg1: {
    type: "scale",
    title: "Ik help graag andere mensen",
  },
  zorg2: {
    type: "scale",
    title: "Ik vind teamsporten leuk",
  },
  zorg3: {
    type: "scale",
    title: "Ik werk graag op een kantoor",
    reverse: true,
  },
  creatief1: {
    type: "scale",
    title: "Ik werk graag in mijn eentje",
  },
  creatief2: {
    type: "scale",
    title: "Ik zou graag mijn eigen huis ontwerpen",
  },
  creatief3: {
    type: "scale",
    title: "Ik doe dingen graag op mijn eigen manier",
  },
  techniek1: {
    type: "scale",
    title: "Ik ben nogal slordig",
    reverse: true,
  },
  techniek2: {
    type: "scale",
    title: "Ik leer graag steeds nieuwe dingen",
  },
  techniek3: {
    type: "scale",
    title: "Ik zoek graag uit hoe iets in elkaar zit",
  },
  onderwijs1: {
    type: "scale",
    title: "Ik vind het leuk om mensen iets uit te leggen",
  },
  onderwijs2: {
    type: "scale",
    title: "Ik kan me goed inleven in anderen",
  },
  onderwijs3: {
    type: "scale",
    title: "Ik ga graag om met kinderen en jongeren",
  },
  "4.1": {
    type: "none",
    title:
      "Voor aanbod dat bij jouw situatie past, hebben we nog drie laatste vragen",
  },
  "4.2": {
    type: "checkbox",
    title: "Welk opleidingsniveau past bij jou?",
    description: "Je kunt meerdere antwoorden kiezen.",
    options: createOptions(niveaus.slice(0, -1)),
    altOption: {
      label: "Ik heb geen voorkeur",
      value: "nopref",
    },
  },
  "4.3": {
    type: "checkbox",
    title: "Hoe lang mag een cursus of opleiding duren?",
    description: "Je kunt meerdere antwoorden kiezen.",
    options: createOptions(duur.slice(0, -1)),
    altOption: {
      label: "Ik heb geen voorkeur",
      value: "nopref",
    },
  },
  "4.4": {
    type: "checkbox",
    title: "Welk soort cursus of opleiding zoek je?",
    description: "Je kunt meerdere antwoorden kiezen.",
    options: typeOptions,
    altOption: {
      label: "Ik heb geen voorkeur",
      value: "nopref",
    },
  },
};
